/* @flow */

import React from 'react'

import type { Vector } from '../types'

export default function ExpertOpinionCreateHelper(props: {
  position: Vector,
  iconSize: number,
  sketchRadius: number,
  onClick: (e: Event) => void,
}) {
  const iconRadius = props.iconSize / 2

  return (
    <circle
      cx={props.sketchRadius + props.sketchRadius * props.position.x}
      cy={props.sketchRadius + props.sketchRadius * props.position.y}
      r={iconRadius}
      fill={'#DDDDDD'}
      onClick={props.onClick}
      style={{ cursor: 'pointer' }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/ExpertOpinionCreateHelper.js